// #region CONSTANTES
export const RESSOURCE_TERMINALS = "terminals";
// #endregion

